import { Component, Input, ChangeDetectionStrategy } from "@angular/core"
import { COMMON_IMPORTS } from "@app/common-imports"
import { Modalable } from "@app/Modalable"
import { LangValPipe } from "@app/utils/lang-val.pipe"

@Component({
	selector: "app-choose-mirror-user",
	imports: [COMMON_IMPORTS, LangValPipe],
	changeDetection: ChangeDetectionStrategy.Eager,
	template: ` <div class="row">
			<div class="col-12">
				<p>{{ "list_of_owners" | langVal }}</p>
			</div>
		</div>
		<div class="row">
			<div class="col-12">
				@for (row of rows; track row) {
					<button
						class="btn btn-primary"
						(click)="onClose.emit(row.user_id)"
					>
						{{ row.name }}
					</button>
				}
				<button
					class="btn btn-primary"
					(click)="onClose.emit()"
				>
					{{ username }}
				</button>
			</div>
		</div>`,
})
export class ChooseMirrorUserComponent extends Modalable {
	@Input() rows: any[] = []
	@Input() username: string = ""
}
